import { ref } from "vue";
import { f as defaultsKey } from "../../../keys-CwytVEYF.mjs";
const bootstrapPlugin = {
  install(app, options) {
    const val = options?.components ?? {};
    app.provide(defaultsKey, ref(val));
  }
};
export {
  bootstrapPlugin
};
//# sourceMappingURL=index.mjs.map
